export default __webpack_public_path__ + "static/circle-gradient-d9cf41e9425cdedeef459b00dfeca3bf.png";